import memoize from 'transmute/memoize';
import getAutomation from 'automation-ui-canvas/selectors/automationSelectors';
import { createSelector } from 'reselect';
import { makeLatestArtifactSelector } from 'automation-ui-canvas/selectors/requestStateSelectors';
import { FetchFlowRevisionActionTypes, FetchFlowValidationObjectTypes } from 'automation-ui-canvas/actions/FlowActions';
import { getPreviousActionId } from 'automation-ui-action-features/records/recordsUtils';
const getCurrentlyStagedFlow = createSelector([getAutomation], automationState => automationState.flows.currentlyStagedFlow);

/**
 * If the staged flow does not match the flowId,
 * return null.
 */
export const getCurrentlyStagedFlowByFlowId = memoize(flowId => createSelector([getCurrentlyStagedFlow], currentlyStagedFlow => {
  if (currentlyStagedFlow && currentlyStagedFlow.getFlowId() === flowId) {
    return currentlyStagedFlow;
  }
  return null;
}));
export const getFlowRevision = (flowId, revisionId) => createSelector([getAutomation], automationState => automationState.flows.allFlowRevisions.getIn([flowId, revisionId]));
export const getUserEditedActionIds = createSelector([getAutomation], automationState => automationState.flows.get('userEditedActionIds'));
export const getHybridPerformanceListCounts = workflowId => createSelector([getAutomation], automationState => automationState.flows.getIn(['hybridPerformanceListCounts', workflowId]));
export const getFlowValidation = flowId => createSelector([getAutomation], automationState => automationState.flows.getIn(['validation', flowId]));
export const getFlowValidationObjectRequestStatus = state => makeLatestArtifactSelector(FetchFlowValidationObjectTypes.getKey())(state).requestState;
export const getFlowRevisionRequestStatus = state => makeLatestArtifactSelector(FetchFlowRevisionActionTypes.getKey())(state).requestState;
const withUndefinedFromNaN = possibleNaN => isNaN(possibleNaN) ? undefined : possibleNaN;
export const getIsLastEditedAction = (flowId, edgeId) => createSelector([getUserEditedActionIds], userEditedActionIdsByFlowId => {
  if (!flowId) {
    return false;
  }
  const userEditedActionIds = userEditedActionIdsByFlowId.get(flowId);
  const lastEditedActionId = userEditedActionIds === null || userEditedActionIds === void 0 ? void 0 : userEditedActionIds.orderOfEditedActionIds.last();
  const fromActionId = withUndefinedFromNaN(getPreviousActionId(edgeId));
  return !!lastEditedActionId && lastEditedActionId === fromActionId;
});